<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 49.038 20.463">
    <g id="Van" transform="translate(0)">
      <path id="Path_86894" data-name="Path 86894"
        d="M1071.312,330.139a3.818,3.818,0,1,0-3.818-3.818,3.822,3.822,0,0,0,3.818,3.818m0-5.909a2.091,2.091,0,1,1-2.091,2.091,2.093,2.093,0,0,1,2.091-2.091"
        transform="translate(-1030.138 -309.676)" :fill="themeColor" />
      <path id="Path_86895" data-name="Path 86895"
        d="M1265.42,330.139a3.818,3.818,0,1,0-3.818-3.818,3.822,3.822,0,0,0,3.818,3.818m0-5.909a2.091,2.091,0,1,1-2.09,2.091,2.093,2.093,0,0,1,2.09-2.091"
        transform="translate(-1253.187 -309.676)" :fill="themeColor" />
      <path id="Path_86896" data-name="Path 86896"
        d="M1088.527,253.777a.785.785,0,0,0,.1-.006.863.863,0,0,0,.758-.957c-.11-.949-.752-5.752-2.634-7.076a27.086,27.086,0,0,0-5.461-2.375c-.925-.332-1.8-.646-2.37-.9-.707-.31-2.041-1.059-3.452-1.852a57.636,57.636,0,0,0-5.95-3.077c-5.425-2.09-23.74-.475-24.518-.4a.864.864,0,0,0-.714.514l-2.791,6.365a.871.871,0,0,0-.072.313l-.155,3.955-.776,1.194a.862.862,0,0,0-.1.716c.654,2.213,2,3.588,3.523,3.588h2.847a.864.864,0,1,0,0-1.728h-2.847c-.616,0-1.319-.814-1.745-1.981l.68-1.046a.862.862,0,0,0,.139-.437l.159-4.03,2.518-5.744c3.024-.248,18.655-1.424,23.235.339a57.123,57.123,0,0,1,5.724,2.971c1.513.849,2.818,1.583,3.6,1.927.626.275,1.527.6,2.48.941a26.986,26.986,0,0,1,5.052,2.162c.927.652,1.676,3.82,1.912,5.862a.864.864,0,0,0,.857.765"
        transform="translate(-1040.353 -236.47)" :fill="themeColor" />
      <path id="Path_86897" data-name="Path 86897"
        d="M1128.157,342.692h17.082a.864.864,0,1,0,0-1.728h-17.082a.864.864,0,0,0,0,1.728"
        transform="translate(-1110.027 -325.385)" :fill="themeColor" />
      <path id="Path_86898" data-name="Path 86898"
        d="M1124.683,283.835a.864.864,0,0,0,0-1.728l-34.174-.12h0a.864.864,0,0,0,0,1.728l34.174.12Z"
        transform="translate(-1083.858 -275.202)" :fill="themeColor" />
      <path id="Path_86899" data-name="Path 86899"
        d="M1332.641,242.729l.065,0,1.637-.121a.863.863,0,0,0,.8-.925.85.85,0,0,0-.925-.8l-1.636.121a.864.864,0,0,0,.063,1.725"
        transform="translate(-1329.554 -240.222)" :fill="themeColor" />
    </g>
  </svg>
</template>


<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
